module.exports = __webpack_public_path__ + "img/storage-tank.32831151.png";